// EditRecordModal.jsx — 정산 기록의 계좌·세금정보 연결 모달 (셸)
// 헬퍼·스타일: editRecordModal.shared.js / 섹션: EditRecordBankSection, EditRecordTaxSection
import React, { useMemo, useState } from 'react';
import { toDateString } from '../../../utils/date';
import { useBodyScrollLock } from '../../../hooks/useBodyScrollLock';
import { useOverlayClickClose } from '../../../hooks/useOverlayClickClose';
import { fmt, getEffectiveItemId, overlayStyle, boxStyle, smallBtnStyle, primaryBtnStyle } from './editRecordModal.shared';
import { stdModalHeaderBar, stdModalHeaderIconBox, stdModalHeaderTitle, stdModalHeaderSub, stdModalCloseBtn } from '../adminlayout/designStandard';
import { EditRecordBankSection } from './EditRecordBankSection';
import { EditRecordTaxSection } from './EditRecordTaxSection';

export function EditRecordModal({
  record,
  bankAccounts,
  taxInfoList,
  bankCodes,
  onLink,
  onAddBankAccount,
  onAddTaxInfo,
  onDeleteBankAccount,
  onDeleteTaxInfo,
  onClose,
  taxTypeEnabled = false,
}) {
  useBodyScrollLock(true);
  const overlayCloseProps = useOverlayClickClose(onClose);
  const settlementDateYmd = record.settlement_date ? toDateString(record.settlement_date) : '';
  const settlementDate = settlementDateYmd || '-';
  const activeAccounts = useMemo(() => bankAccounts.filter((b) => b.is_active), [bankAccounts]);
  const activeTaxList = useMemo(() => taxInfoList.filter((t) => t.is_active), [taxInfoList]);
  const effectiveBankId = useMemo(
    () => getEffectiveItemId(activeAccounts, settlementDateYmd),
    [activeAccounts, settlementDateYmd],
  );
  const effectiveTaxId = useMemo(
    () => getEffectiveItemId(activeTaxList, settlementDateYmd),
    [activeTaxList, settlementDateYmd],
  );

  const [selBank, setSelBank] = useState(record.bank_account_id || '');
  const [selTax, setSelTax] = useState(record.tax_info_id || '');

  const handleSave = () => {
    onLink(record.id, selBank || null, selTax || null);
  };

  return (
    <div style={overlayStyle} {...overlayCloseProps}>
      <div style={boxStyle}>
        {/* 헤더 — 검정 표준 밴드 (카드 패딩 상쇄용 음수 마진) */}
        <div style={{ ...stdModalHeaderBar(12), margin: '-18px calc(-1 * clamp(12px, 4vw, 22px)) 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            <div style={stdModalHeaderIconBox}>✏️</div>
            <div style={{ minWidth: 0 }}>
              <div style={stdModalHeaderTitle}>계좌·세금정보 연결</div>
              <div style={stdModalHeaderSub}>
                {record.user_name} · {settlementDate} 정산 · {fmt(record.amount)}원
              </div>
            </div>
          </div>
          <button style={stdModalCloseBtn} onClick={onClose}>✕</button>
        </div>

        <EditRecordBankSection
          record={record}
          activeAccounts={activeAccounts}
          effectiveBankId={effectiveBankId}
          settlementDateYmd={settlementDateYmd}
          selBank={selBank}
          setSelBank={setSelBank}
          bankCodes={bankCodes}
          onAddBankAccount={onAddBankAccount}
          onDeleteBankAccount={onDeleteBankAccount}
        />

        <EditRecordTaxSection
          record={record}
          activeTaxList={activeTaxList}
          effectiveTaxId={effectiveTaxId}
          settlementDateYmd={settlementDateYmd}
          selTax={selTax}
          setSelTax={setSelTax}
          onAddTaxInfo={onAddTaxInfo}
          onDeleteTaxInfo={onDeleteTaxInfo}
          taxTypeEnabled={taxTypeEnabled}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
          <button style={smallBtnStyle} onClick={onClose}>취소</button>
          <button style={primaryBtnStyle} onClick={handleSave}>저장</button>
        </div>
      </div>
    </div>
  );
}
